import * as React from 'react';
import { connect } from 'react-redux';
import { getLastMatchesWinsAndLossesByTeamIds } from '../reducers/statsTeamLastX';
import { getStaticText } from "../reducers/staticTexts";
import { getTranslations } from "../reducers/translations";
import { getSRPlayerIdsByMatchId } from "../reducers/matches";
import { getActiveChannelId } from "../reducers/gui";
import { getMatchIdByChannelId } from "../reducers/timings";

import StatsFormPresentation from '../presentations/StatsForm/StatsFormPresentation';
/*
Get the percentage of wins in relation to the last 5 matches
*/
const getOutcomePercentage = ( winsAndLossesArray: Array<any> = [], matcher: any = 'won' ) => {
  // calculate
  let result = Math.round( winsAndLossesArray.filter( ( elem: any ) => elem === matcher ).length / winsAndLossesArray.length * 100 );

  // if result is "NaN" which happens initially when a channel is switched just return 0
  return isNaN( result ) ? 0 : result;
};

const mapStateTopProps = ( state: any ) => {
	// get ids of clubs in currently selected channel
	let activeChannelId: number = getActiveChannelId( state );
	let matchId: number = getMatchIdByChannelId( state, activeChannelId );
	let clubIds: any = getSRPlayerIdsByMatchId( state, matchId );
	

	// fetches an array containing the last 5 games of a club (player)
	let winsAndLossesHome = getLastMatchesWinsAndLossesByTeamIds( state, activeChannelId, 'home' );
	let winsAndLossesAway = getLastMatchesWinsAndLossesByTeamIds( state, activeChannelId, 'away' );

	// calculates the win/loss rate in %
	let outcomePercentageHome: any = getOutcomePercentage( winsAndLossesHome );
	let outcomePercentageAway: any = getOutcomePercentage( winsAndLossesAway );

  	return {
    	outcomePercentageHome: outcomePercentageHome,
    	outcomePercentageAway: outcomePercentageAway,
		winsAndLossesHome: winsAndLossesHome,
		winsAndLossesAway: winsAndLossesAway,
		staticTexts: getStaticText( state ),
		translations: getTranslations( state ),
		activeChannelId: activeChannelId,
		isValidHome: !!winsAndLossesHome.length,
		isValidAway: !!winsAndLossesAway.length,
	}
};

export default connect( mapStateTopProps )( StatsFormPresentation )
